import React, {Component} from "react"
import {injectIntl} from 'react-intl'
import {ButtonGroup, ButtonToolbar, Button} from 'react-bootstrap'

class ButtonGroupSelect extends Component{

  constructor(data){
    super(data)
    this.state = {
      selectedValue: this.props.value
    }
  }

  render(){

    const format = this.props.intl.formatMessage
    const options = this.props.options || []
    const onSelect = this.props.onSelect || function () {}

    return (
      <ButtonToolbar>
        <ButtonGroup bsSize="xsmall">
          {
            options.map(
              (o)=>{
                const active = this.state.selectedValue === o.value
                return <Button
                          active={active}
                          onClick={()=>{
                            this.setState({selectedValue:o.value})
                            onSelect(o.value)
                          }}>
                          {o.label?o.label:format({id:o.value})}
                        </Button>
              }
            )
          }
        </ButtonGroup>
      </ButtonToolbar>
    )
  }
}

export default injectIntl(ButtonGroupSelect)



// WEBPACK FOOTER //
// ./src/components/ButtonGroupSelect.js